/**
 * When running the local server, replaces the online domain with the local
 */
export const makeEnvironmentUrl = url => {
  if (process.env.REACT_APP_MODE === 'local' || process.env.REACT_APP_MODE === 'homolog') {
    if (/\.aspx$/.test(url)) return url;
    const regex = /^(?:https?:\/\/)?[^/]+(\/.*)?$/;
    const match = url.match(regex);
    return match && match[1] ? `${process.env.REACT_APP_URL}${match[1]}` : `${process.env.REACT_APP_URL}/dashboard`;
  } else {
    if (url?.includes('dashboard-geral')) {
      return '/dashboard';
    }
    return url;
  }
};
